module.exports = __webpack_public_path__ + "static/currency-f28c8c91740d42b47f0c8eeb4ca4e4c6.png";